import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface EventListButtonProps {
    acceptanceErrorMessageVisible: boolean;
    onClick: () => void;
}

export const EventListButton = (props: EventListButtonProps) => {

    return (
        <button id="EventList" className="btn btn-primary" type="button" onClick={() => props.onClick()} onKeyDown={OnIgnoreEnter}>
            Events List&nbsp;{props.acceptanceErrorMessageVisible ? <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning" /> : null}
        </button>
    );
}
